export const c_dual_list_selector__item_PaddingLeft = {
  "name": "--pf-c-dual-list-selector__item--PaddingLeft",
  "value": "calc(calc(calc(1rem + 0.5rem + 0.875rem) - 1rem) * 10 + calc(1rem + 0.5rem + 0.875rem))",
  "var": "var(--pf-c-dual-list-selector__item--PaddingLeft)"
};
export default c_dual_list_selector__item_PaddingLeft;